export default {
  statusWaiting: 'waiting',
  statusRegistered: 'registered',
  statusPresent: 'present',
  statusCancelled: 'cancelled',
  statusAWR: 'awr',
  statusAWNR: 'awnr',
  statusLabel(status) {
    switch(status) {
      case this.statusWaiting:
        return Core.Definition.getDefinition('En attente');
        break
      case this.statusRegistered:
        return Core.Definition.getDefinition('Inscrit');
        break
      case this.statusPresent:
        return Core.Definition.getDefinition('Présent');
        break
      case this.statusCancelled:
        return Core.Definition.getDefinition('Annulé');
        break
      case this.statusAWR:
        return Core.Definition.getDefinition('Abs. motivée');
        break
      case this.statusAWNR:
        return Core.Definition.getDefinition('Abs. non motivée');
        break
      default:
        return ''
        break
    }
  },
  statusOptions(keys) {
    if (keys === undefined) {
      keys = [this.statusWaiting, this.statusRegistered, this.statusPresent, this.statusCancelled, this.statusAWR, this.statusAWNR]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.statusLabel(key)
          }
      )
    }
    return options
  }
}
